import React from "react";

function NameCard({ name, email, title, affiliations, children, className }) {
  return (
    <div className={`${className} text-center flex flex-col items-center`}>
      {children}
      <h1 className="text-white text-lg font-semibold">{name}</h1>
      <p className="text-white text-[16px]">{title}</p>
      <p className="text-blue-pale text-[16px]">{email}</p>
      <div className="mt-1">
        {affiliations.map((affiliation, index) => (
          <p key={index} className="text-blue-pale text-[16px]">
            {affiliation}
          </p>
        ))}
      </div>
    </div>
  );
}

export default NameCard;
